import React from "react";
import SearchBrandRankings from "../searchBrandRankings/SearchBrandRankings";
import SearchPopularKeyword from "../searchPopularKeyword/SearchPopularKeyword";
import PropTypes from "prop-types";

/**
 * 검색어(searchQuery) 가 비어있을때
 * @returns {Element}
 * @constructor
 */
const EmptySearchView = ({ handleOnBrandClick, handleOnQueryClick }) => {
  return (
    <div>
      <SearchPopularKeyword handleOnQueryClick={handleOnQueryClick} />
      <SearchBrandRankings
        rankingType={"popular"}
        handleOnBrandClick={handleOnBrandClick}
      />
    </div>
  );
};

EmptySearchView.propTypes = {
  handleOnBrandClick: PropTypes.func,
  handleOnQueryClick: PropTypes.func,
};

export default EmptySearchView;
